const Collapsibles = (function () {
    'use strict'

    const toggle = function(el) {
        const collapsibleHeader = $(el).parent();
        if(typeof $(collapsibleHeader).attr('data-is-open') === 'undefined') {
            $(collapsibleHeader).attr('data-is-open', '');
        } else {
            $(collapsibleHeader).removeAttr('data-is-open');
        }
    };

    const init = function () {

    };

    return {
        init: init,
        toggle: toggle,
    }
})();
